import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ChakraProvider, extendTheme } from '@chakra-ui/react';
import { theme as proTheme } from '@chakra-ui/pro-theme'
import { ApiProvider } from './contexts/ApiProvider';
import { Auth0Provider } from '@auth0/auth0-react';
import { StorageProvider } from './contexts/StorageProvider';
import { OrganizationProvider } from './contexts/OrganizationProvider';
import { AuthProvider } from "react-oidc-context";
import { ZitadelProvider } from './contexts/ZitadelProvider';
import { User } from 'oidc-client-ts';
import { ProjectProvider } from './contexts/ProjectProvider';



const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const theme = extendTheme(
  {
    colors: { 
      ...proTheme.colors, 
      brand: {
        50: proTheme.colors.gray["100"],
        100: proTheme.colors.gray["200"],
        200: proTheme.colors.gray["300"],
        300: proTheme.colors.gray["400"],
        400: proTheme.colors.gray["500"],
        500: proTheme.colors.gray["600"],
        600: proTheme.colors.gray["700"],
        700: proTheme.colors.gray["800"],
        800: proTheme.colors.gray["900"],
        900: "#11121A"
      },
    },
  },
  proTheme,
);

root.render(
  <React.StrictMode>
    <ChakraProvider theme={theme}>
      <ProjectProvider>
        <ZitadelProvider 
          loginRedirectUri={"https://baukg.app/web"}
          logoutRedirectUri={"https://baukg.app"}
        >
          <OrganizationProvider>
            <ApiProvider
              baseUri="https://api.baukg.app/api"
            >
              <StorageProvider>
                <App />
              </StorageProvider>
            </ApiProvider>
          </OrganizationProvider>
        </ZitadelProvider>
      </ProjectProvider>

      {/*
      <OrganizationProvider
        baseUri="https://api.baukg.app/v1"
        callbackPath='web/login'
      >
        <Auth0Provider
          domain="auth.baukg.app" // baukgapp.eu.auth0.com
          clientId="3iKQ00SeADv9nrEzUuTUMqf0DQULqLlA"
          redirectUri={"https://baukg.app/web/login"/}
          audience="https://api.baukg.app/"
          useRefreshTokens={true}
        >
          <AuthProvider 
            logoutRedirectUri={"https://www.baukg.app"}
          >
            <ApiProvider
              baseUri="https://api.baukg.app/v1"
            >
              <StorageProvider>
                <App />
              </StorageProvider>
            </ApiProvider>
          </AuthProvider>
        </Auth0Provider>
      </OrganizationProvider>
      */}


    </ChakraProvider>
  </React.StrictMode>
);
